<dx-tag-box
  *ngIf="tagBox"
  [dataSource]="dataSource"
  [valueExpr]="control?.kodField"
  [displayExpr]="displayField"
  [value]="selectedKeys | tagBoxValuePipe"
  (onValueChanged)="onSelectionChanged($event)"
  [disabled]="isReadOnly"
  [readOnly]="isReadOnly"
  [showSelectionControls]="showSelectionControls"
  (onMultiTagPreparing)="onMultiTagPreparing($event)"
  [showMultiTagOnly]="false"
  selectAllMode="allPages"
>
  <dx-validator>
    <ng-container *ngIf="isRequired">
      <dxi-validation-rule
        type="required"
        [message]="labelText + ': Zorunludur'"
      >
      </dxi-validation-rule>
    </ng-container>
    <ng-container *ngFor="let rule of validationRules">
      <dxi-validation-rule
        [type]="rule.type"
        [message]="rule.message"
        [pattern]="rule.pattern"
        [reevaluate]="rule.reevaluate"
      >
      </dxi-validation-rule>
    </ng-container>
  </dx-validator>
</dx-tag-box>

<dx-drop-down-box
  *ngIf="!tagBox"
  [value]="selectedKeys"
  [dataSource]="dataSource"
  [valueExpr]="control?.kodField"
  [displayExpr]="displayExpr"
  fieldTemplate="field"
  [(opened)]="isOpened"
  [showClearButton]="true"
  [readOnly]="isReadOnly"
  [labelMode]="labelMode"
  (onOptionChanged)="onOptionChanged($event)"
>
  <div *dxTemplate="let data of 'field'">
    <dx-text-box style="border:0px;"
      [value]="(selectedKeys || []).join(',')"
      [readOnly]="true"
    >
      <dxi-button name="drop" location="after" [options]="{ icon: 'drop' }"></dxi-button>
    </dx-text-box>
  </div>
  <div *dxTemplate="let data of 'content'">
    <dk-dx-data-table2
      [dataSource]="dataSource"
      [columnList]="columns"
      [gridCtlList]="control?.dlistMetadata"
      [selectedRowKeys]="selectedKeys"
      (selectedRowKeysChange)="onSelectionChanged($event)"
      [isGroupingYn]="false"
      [columnTransactions]="false"
      [height]="'350px'"
      [baseTable]="false"
      [manuelSelectionManage]="true"
    >
    </dk-dx-data-table2>
  </div>
  <dx-validator>
    <ng-container *ngIf="isRequired">
      <dxi-validation-rule
        type="required"
        [message]="labelText + ': Zorunludur'"
      >
      </dxi-validation-rule>
    </ng-container>
    <ng-container *ngFor="let rule of validationRules">
      <dxi-validation-rule
        [type]="rule.type"
        [message]="rule.message"
        [pattern]="rule.pattern"
        [reevaluate]="rule.reevaluate"
      >
      </dxi-validation-rule>
    </ng-container>
  </dx-validator>
</dx-drop-down-box>
